import { render, staticRenderFns } from "./NegativeBalanceInsightPopup.vue?vue&type=template&id=a0b486fe&scoped=true"
import script from "./NegativeBalanceInsightPopup.vue?vue&type=script&lang=js"
export * from "./NegativeBalanceInsightPopup.vue?vue&type=script&lang=js"
import style0 from "./NegativeBalanceInsightPopup.vue?vue&type=style&index=0&id=a0b486fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b486fe",
  null
  
)

export default component.exports